import React from 'react';
import { AlertBlock } from '../AlertBlock';

interface ExceptionsViewerProps {
  exceptions: unknown[];
  redactedException?: string;
  tiffException?: string;
}

export default function ExceptionsViewer({
  exceptions,
  redactedException,
  tiffException,
}: ExceptionsViewerProps) {
  return (
    <div className="iio-exceptions-viewer">
      {redactedException && (
        <AlertBlock type="danger" heading="Redaction Error">
          {redactedException}
        </AlertBlock>
      )}
      {tiffException && (
        <AlertBlock type="danger" heading="TIFF Error">
          {tiffException}
        </AlertBlock>
      )}
      {exceptions.length > 0 && (
        <div className="iio-exceptions-list">
          <h4>Processing Exceptions</h4>
          <ul>
            {exceptions.map((ex, i) => (
              <li key={i}>{String(ex)}</li>
            ))}
          </ul>
        </div>
      )}
      {!redactedException && !tiffException && exceptions.length === 0 && (
        <AlertBlock type="info">No exception details available.</AlertBlock>
      )}
    </div>
  );
}
